import type { PortfolioFilteredStatisticsResource } from "api/generated";
import type { StudentProfileStatistics } from "portfolio/types";

export const studentProfileStatisticsFromDto = (
  dto: PortfolioFilteredStatisticsResource,
): StudentProfileStatistics => ({
  totalActivities: dto.total_activities,
  totalAttachments: dto.total_attachments,
  totalReferences: dto.total_references,
  totalSkills: dto.total_skills,
});
